import Aldagram from './aldagram'

export default Aldagram
